import { AbbreviationKey } from './AbbreviationItems';

export type ExplainerKey =
	| Content.Theme
	| AbbreviationKey
	| 'AsPDF'
	| 'LegalGuidanceForMoreInfo'
	| 'TheLegalGuidance'
	| 'ThePageDoesNotExistSearchTeaser';

interface DictionaryFunctions {
	get(key: ExplainerKey): string;
}

export const ExplainerItems = (getValue: (key: string, defaultValue?: string) => string): DictionaryFunctions => {
	return {
		get: (key: ExplainerKey): string => {
			switch (key) {
				case 'LegalGuidanceForMoreInfo':
					return getValue('Explainer.LegalGuidanceForMoreInfo', 'For uddybende og fyldestgørende juridisk information, se');
				case 'TheLegalGuidance':
					return getValue('Explainer.TheLegalGuidance', 'Den juridiske vejledning');
				case 'AsPDF':
					return getValue('Explainer.AsPDF', 'Som PDF');

				// Agencies
				case 'ADST':
					return getValue('Explainer.ADST', 'Administrations- og Servicestyrelsen');
				case 'FDS':
					return getValue('Explainer.FDS', 'Foreningen af Danske Skatteankenævn');
				case 'GAELDST':
					return getValue('Explainer.GAELDST', 'Gældsstyrelsen');
				case 'ITTI':
					return getValue('Explainer.ITTI', 'It-tilsynet');
				case 'MOTORST':
					return getValue('Explainer.MOTORST', 'Motorstyrelsen');
				case 'LOTTERIREGLER':
					return getValue('Explainer.LOTTERIREGLER', 'Lotteriregler');
				case 'ROFUS':
					return getValue('Explainer.ROFUS', 'Rofus');
				case 'SANST':
					return getValue('Explainer.SANST', 'Skatteankestyrelsen');
				case 'SKAT':
					return getValue('Explainer.SKAT', 'Skat');
				case 'SKM':
					return getValue('Explainer.SKM', 'Skatteministeriet');
				case 'SKTFV':
					return getValue('Explainer.SKTFV', 'Skattefovaltningen');
				case 'SKTST':
					return getValue('Explainer.SKTST', 'Skattestyrelsen');
				case 'SPIL':
					return getValue('Explainer.SPIL', 'Spillemyndigheden');
				case 'SPILLEMYNDIGHEDEN':
					return getValue('Explainer.SPILLEMYNDIGHEDEN', 'Spillemyndigheden');
				case 'STOPSPILLET':
					return getValue('Explainer.STOPSPILLET', 'Stopspillet');
				case 'STYRPAASPILLET':
					return getValue('Explainer.STYRPAASPILLET', 'Styrpaaspillet');
				case 'TOLDST':
					return getValue('Explainer.TOLDST', 'Toldstyrelsen');
				case 'UFST':
					return getValue('Explainer.UFST', 'Udviklings- og Forenklingsstyrelsen');
				case 'VURDST':
					return getValue('Explainer.VURDST', 'Vurderingsstyrelsen');
				case 'WEBGUIDE':
					return getValue('Explainer.WEBGUIDE', 'Udviklings- og Forenklingsstyrelsen');
				case 'ZISE':
					return getValue('Explainer.ZISE', 'Zise');
				// Abbreviations
				case 'Approximately':
					return getValue('Explainer.Approximately', 'Cirka');
				case 'Clock':
					return getValue('Explainer.Clock', 'Klokken');
			}
		},
	};
};
